import React from 'react';
import './Icon.scss';
const rootClassName = 'icon-component';

export const CopyIcon = () => {
  return (
    <svg
      className={rootClassName}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7 1H20C21.1046 1 22 1.89543 22 3V18C22 19.1046 21.1046 20 20 20H19V21C19 22.1046 18.1046 23 17 23H14H4C2.89543 23 2 22.1046 2 21V17V6C2 4.89543 2.89543 4 4 4H5V3C5 1.89543 5.89543 1 7 1ZM6 5H5H4C3.44772 5 3 5.44772 3 6V21C3 21.5523 3.44772 22 4 22H17C17.5523 22 18 21.5523 18 21V20V19V6C18 5.44772 17.5523 5 17 5H6ZM19 19V6C19 4.89543 18.1046 4 17 4H6V3C6 2.44772 6.44772 2 7 2H20C20.5523 2 21 2.44772 21 3V18C21 18.5523 20.5523 19 20 19H19Z'
      />
    </svg>
  );
};
